module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAcCAMAAAC02HQrAAAAaVBMVEUAAAD////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////8G612AAAAInRSTlMA48XasIZPIPvrqGo0EwX18tGgi2JXQi4NCeW6k354bEg+sFinZQAAAJNJREFUKM9l0dkSgyAMQNGILCKLa6vdW/7/IzvDgHGS+3geIARQEVip1dxSkhu3lJadW7o7YjnxI5brTbUecXjfCuoJtb1AaW1QpS+4qw71GYqaGXGC2lVUGwHz5dgGKa6Wmjsu7/A0HCfLJunY4TTdoPLzPpatQaCIL92VdWx/SwBiD092f3wn2viKQGw2QNPA+gOETx071rJi4wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/images/guess_word/next_arrow.png
// module id = hH3f
// module chunks = 1